import { AbstractControl } from "@angular/forms";

export class CustomValidators {

    public static passwordMatchValidator(control: AbstractControl) {


        const password: string = control.get('password') ? control.get('password').value : null;
        const confirmPassword: string = control.get('confirmPassword') ? control.get('confirmPassword').value : null;
        if ((password && confirmPassword) && (password !== confirmPassword)) {
            control.get('confirmPassword') ? control.get('confirmPassword').setErrors({ NoPassswordMatch: true }) : null;
        } else if (!password) {
            control.get('confirmPassword') ? control.get('confirmPassword').setErrors({ NoPassswordMatch: true }) : null;
        } else if ((password && confirmPassword) && (password === confirmPassword)) {
            control.get('confirmPassword') ? control.get('confirmPassword').setErrors(null) : null;
        }
    }

    public static passwordRepeatValidator(control: AbstractControl) {
        const password: string = control.get('password') ? control.get('password').value : null;
        const currentPassword: string = control.get('currentPassword') ? control.get('currentPassword').value : null;
        if ((password && currentPassword) && (password === currentPassword)) {
            control.get('password') ? control.get('password').setErrors({ PasswordRepeat: true }) : null;
        }
    }
}